module.exports = __webpack_public_path__ + "img/person_fill.60ff7956.svg";